/**
 * API endpoint for public programs list.
 */
export const PROGRAMS_API = "/programs/";

/**
 * API endpoint for authenticated user's programs.
 * For detail, append program ID: `/programs/user/{id}/`
 */
export const USER_PROGRAMS_API = "/programs/user/";

/**
 * Default page size for programs list.
 */
export const PROGRAMS_PAGE_SIZE = 20;

/**
 * Program role slugs matching backend ProgramRole.slug values.
 */
export const PROGRAM_ROLE_SLUG = {
  ENROLLED_PARTICIPANT: "enrolled_participant",
  ONBOARDED_PARTICIPANT: "onboarded_participant",
  PROSPECTIVE_PARTICIPANT: "prospective_participant",
  WITHDRAWN_USER: "withdrawn_user",
  ORG_ADMIN: "org_admin",
  ORG_ONBOARDER: "org_onboarder",
  SOFT_INVITE_ORG_ADMIN: "soft_invite_org_admin",
} as const;

/**
 * Program phase status values, mirroring backend ProgramPhase.PHASE_STATUS_CHOICES.
 */
export const PHASE_STATUS = {
  ACTIVE: "active",
  UPCOMING: "upcoming",
  COMPLETED: "completed",
} as const;

export type PhaseStatus = (typeof PHASE_STATUS)[keyof typeof PHASE_STATUS];
